import { useLocation } from 'react-router-dom';
import { parseRoute } from './parser';
import type { RouteMatch } from './types';

export function useRouteMatch(): RouteMatch {
  const location = useLocation();
  return parseRoute(location.pathname);
}